module.exports = [
  [
    { name: 'requisitions', route: 'requisitions', hasNotifications: true },
    { name: 'all test results', route: 'test-results', hasNotifications: true },
    {
      name: 'covid-19 test results',
      route: 'test-results/covid-19',
      hasNotifications: true
    }
  ],
  [
    { name: 'patients', route: 'patients', hasNotifications: false },
    { name: 'consultations', route: 'consultations', hasNotifications: false }
  ]
]
